import React, { useState } from 'react';
import { Select as MaterialUiSelect, SelectProps } from '@mui/material';
import { ISharedProps } from '../../tools/ISharedProps';
import { ISharedFormProps } from '../ISharedFormProps';
import { makeStyles } from '~/UIKit/Style';
import { ChevronRight } from '@mui/icons-material';
import classNames from 'classnames';

interface ISelectProps<T> extends SelectProps<T>, ISharedProps, ISharedFormProps {
  newDesign?: boolean;
  renderValue?: any;
}
const useStyles = makeStyles({
  root: {
    '&:before': {
      borderBottom: 'none !important',
    },
    '&:after': {
      borderBottom: 'none !important',
    },
  },
  selectMenu: {
    width: '100%',
    height: '100%',
    boxSizing: 'inherit',
    display: 'flex',
    alignItems: 'center',
  },
  selectArrow: {
    top: 'calc(50% - 12px)',
    right: 0,
    position: 'absolute',
    pointerEvents: 'none',
    paddingLeft: 'inherit',
    paddingRight: 'inherit',
    boxSizing: 'content-box',
  },
});

export const Select = <T extends any>({ newDesign, className, ...props }: ISelectProps<T>) => {
  const [open, setOpen] = useState(false);
  const { classes } = useStyles();
  if (newDesign) {
    return (
      <MaterialUiSelect
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        classes={{ select: classes.selectMenu }}
        className={classNames(classes.root, className)}
        value={props.field?.value}
        onChange={props.field?.onChange}
        onBlur={props.field?.onBlur}
        name={props.field?.name}
        IconComponent={() => (
          <ChevronRight
            className={classes.selectArrow}
            style={{
              transform: open ? 'rotate(90deg)' : 'rotate(0deg)',
              transition: 'transform 0.3s ease-in-out !important',
            }}
          />
        )}
        variant="standard"
        {...props}
      />
    );
  }
  const newProps = {
    ...props,
    renderValue: !props.field?.value
      ? (value: string | null) => (!value ? props.placeholder : value)
      : undefined,
  } as any;
  return (
    <MaterialUiSelect
      value={props.field?.value}
      onChange={props.field?.onChange}
      onBlur={props.field?.onBlur}
      name={props.field?.name}
      className={className}
      displayEmpty={!props.field?.value}
      {...newProps}
    />
  );
};
